import GameModel from '../model/GameModel';
import InitState from 'Engine/states/InitState';
import IdleState from 'Engine/states/IdleState';
import RequestRollingState from './RequestRollingState';
import StopRollingState from './StopRollingState';
import ShowWinState from './ShowWinState';
import MinimalRollingState from './MinimalRollingState';
import EntryPoint from 'Engine/EntryPoint';
import ShowStartScreenState from './showStartScreenState';
import StopWinState from './StopWinState';
import FreespinsOutState from './FreespinsOutState';
import FreespinsInState from './FreespinsInState';
import WaitUserInteractionState from './WaitUserInteractionState';
import eStateTypes from '../enums/eStateTypes'

export const StatesConfig = [
  {
    name: eStateTypes.EST_INIT, class: InitState, transitions: [
      {
        to: eStateTypes.EST_START_SCREEN, condition: function () {
          return true;
        }
      }
    ], entry: true
  },
  {
    name: eStateTypes.EST_IDLE, class: IdleState, transitions: [
      {
        to: eStateTypes.EST_REQUEST_ROLLING, condition: function () {
          return true;
        }
      },
    ]
  },
  {
    name: eStateTypes.EST_REQUEST_ROLLING, class: RequestRollingState, transitions: [
      {
        to: eStateTypes.EST_MINIMAL_ROLLING, condition: function () {
          return true;
        }
      }
    ]
  },
  {
    name: eStateTypes.EST_MINIMAL_ROLLING, class: MinimalRollingState, transitions: [
      {
        to: eStateTypes.EST_STOP_ROLLING, condition: function () {
          return true;
        }
      }
    ]
  },
  {
    name: eStateTypes.EST_STOP_ROLLING, class: StopRollingState, transitions: [
      {
        to: eStateTypes.EST_SHOW_WIN, condition: function () {
          return GameModel.totalWin;
        }
      },
      {
        to: eStateTypes.EST_FREE_SPINS_OUT, condition: function () {
          return EntryPoint.GameModel.freespinsEnabled && !EntryPoint.GameModel.isFreeSpinsMode;
        }
      },
      {
        to: eStateTypes.EST_FREE_SPINS_IN, condition: function () {
          return EntryPoint.GameModel.freespinsTriggered;
        }
      },
      {
        to: eStateTypes.EST_IDLE, condition: function () {
          return true;
        }
      }
    ]
  },
  // {
  //   name: eStateTypes.EST_SHOW_LINES_WIN, class: ShowLinesWinState, transitions: [
  //     {
  //       to: eStateTypes.EST_SHOW_WINNINGS, condition: function () {
  //         return true;
  //       }
  //     }
  //   ]
  // },
  {
    name: eStateTypes.EST_SHOW_WIN, class: ShowWinState, transitions: [
      {
        to: eStateTypes.EST_STOP_WIN, condition: function () {
          return true;
        }
      }
    ]
  },
  {
    name: eStateTypes.EST_STOP_WIN, class: StopWinState, transitions: [
      {
        to: eStateTypes.EST_FREE_SPINS_OUT, condition: function () {
          return EntryPoint.GameModel.freespinsEnabled && !EntryPoint.GameModel.isFreeSpinsMode;
        }
      },
      {
        to: eStateTypes.EST_FREE_SPINS_IN, condition: function () {
          return EntryPoint.GameModel.freespinsTriggered;
        }
      },
      {
        to: eStateTypes.EST_IDLE, condition: function () {
          return true;
        }
      }
    ]
  },
  // {
  //   name: eStateTypes.EST_SHOW_WINNINGS, class: ShowWinningsState, transitions: [
  //     {
  //       to: eStateTypes.EST_SHOW_WIN, condition: function () {
  //         return GameModel.totalWin;
  //       }
  //     },
  //     {
  //       to: eStateTypes.EST_FREE_SPINS_OUT, condition: function () {
  //         return EntryPoint.GameModel.freespinsEnabled && !EntryPoint.GameModel.isFreeSpinsMode;
  //       }
  //     },
  //     {
  //       to: eStateTypes.EST_FREE_SPINS_IN, condition: function () {
  //         return EntryPoint.GameModel.freespinsTriggered;
  //       }
  //     },
  //     {
  //       to: eStateTypes.EST_IDLE, condition: function () {
  //         return true;
  //       }
  //     }
  //   ]
  // },

  {
    name: eStateTypes.EST_START_SCREEN, class: ShowStartScreenState, transitions: [
      {
        to: eStateTypes.EST_WAIT_USER_INTERACTION, condition: function () {
          return EntryPoint.GameModel.isFreeSpinsMode;
        }
      },
      {
        to: eStateTypes.EST_IDLE, condition: function () {
          return true;
        }
      }
    ]
  },
  {
    name: eStateTypes.EST_FREE_SPINS_IN, class: FreespinsInState, transitions: [
      {
        to: eStateTypes.EST_IDLE, condition: function () {
          return true;
        }
      }
    ]
  },
  {
    name: eStateTypes.EST_FREE_SPINS_OUT, class: FreespinsOutState, transitions: [
      {
        to: eStateTypes.EST_IDLE, condition: function () {
          return true;
        }
      }
    ]
  },
  {
    name: eStateTypes.EST_WAIT_USER_INTERACTION, class: WaitUserInteractionState, transitions: [
      {
        to: eStateTypes.EST_IDLE, condition: function () {
          return true;
        }
      }
    ]
  },
];
